import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useLoginApi } from '../../../api/login/useLoginApi';

import Login from '../../../components/screens/auth/login/Login';

const LoginContainer = () => {
  const navigate = useNavigate();

  const { login } = useLoginApi();

  const handleLogInClick = (email: string, password: string) => {
    login({ email, password }, () => navigate('/programmes'));
  };

  return <Login handleLogInClick={handleLogInClick} />;
};

export default LoginContainer;
